import type { MultiActionsType } from '@atlassian/jira-bulk-operations-common/src/controllers/use-form-submit-state/types.tsx';
import type { Mutable } from '../../../../common/types.tsx';
import type { CardId, Card } from '../../../../model/types.tsx';
import {
	type OptimisticUiMeta,
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiMeta,
} from '../../meta/optimistic-ui-meta.tsx';

export const CARDS_BULK_OPERATIONS_REQUESTS =
	'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_REQUESTS' as const;

export type CardBulkOperationsPayloadData = Mutable<
	Partial<
		Pick<
			Card,
			| 'assignee'
			| 'dueDate'
			| 'priority'
			| 'isFlagged'
			| 'estimate'
			| 'parentId'
			| 'statusId'
			| 'isDone'
		>
	>
> & {
	labels?: {
		value: string[];
		action: MultiActionsType;
	};
	fixVersions?: {
		value: string[];
		action: MultiActionsType;
	};
};

type CardIds = CardId[];

export type CardsBulkOperationsPayload = {
	cardIds: CardIds;
	data: CardBulkOperationsPayloadData;
};

export type CardsBulkOperationsRequestsAction = {
	type: typeof CARDS_BULK_OPERATIONS_REQUESTS;
	payload: CardsBulkOperationsPayload[];
	meta: OptimisticUiMeta;
};

export const cardsBulkOperationsRequests = (
	payload: CardsBulkOperationsPayload[],
): CardsBulkOperationsRequestsAction => ({
	type: CARDS_BULK_OPERATIONS_REQUESTS,
	payload,
	meta: beginOptimisticUiMeta(),
});

export const CARDS_BULK_OPERATIONS_SUCCESS =
	'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_SUCCESS' as const;

export type CardsBulkOperationsSuccessAction = {
	type: typeof CARDS_BULK_OPERATIONS_SUCCESS;
	meta: OptimisticUiMeta;
	payload: CardIds;
};

export const cardsBulkOperationsSuccess = (
	optimisticId: string,
	payload: CardIds,
): CardsBulkOperationsSuccessAction => ({
	type: CARDS_BULK_OPERATIONS_SUCCESS,
	meta: commitOptimisticUiMeta(optimisticId),
	payload,
});

export const CARDS_BULK_OPERATIONS_FAILURE =
	'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_FAILURE' as const;

export type CardsBulkOperationsFailureAction = {
	type: typeof CARDS_BULK_OPERATIONS_FAILURE;
	payload: CardId[];
	meta: OptimisticUiMeta;
};

export const cardsBulkOperationsFailure = (
	optimisticId: string,
	payload: CardId[],
): CardsBulkOperationsFailureAction => ({
	type: CARDS_BULK_OPERATIONS_FAILURE,
	meta: revertOptimisticUiMeta(optimisticId),
	payload,
});

export type Action =
	| CardsBulkOperationsRequestsAction
	| CardsBulkOperationsSuccessAction
	| CardsBulkOperationsFailureAction;
